/*
 * @Author: your name
 * @Date: 2021-07-29 11:21:17
 * @LastEditTime: 2021-07-31 15:11:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \hpss-ui\src\api\crmedical\value\valueboundary.js
 */
import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api//v4ward/valueBoundary/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api//v4ward/valueBoundary/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api//v4ward/valueBoundary/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api//v4ward/valueBoundary/save', params,options);

export const update = (params, options) =>
request.post('/api//v4ward/valueBoundary/update', params,options);

export const getType = (params, options) =>
request.get('/api//v4ward/valueBoundary/getType', Object.assign({}, options, { params }));

